// extracted by mini-css-extract-plugin
module.exports = {"container":"LessonLoader_container__2Z2J_"};